import { observer } from 'mobx-react-lite';

import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import { ServicesSubSectionHeader } from '../../services/services-subsection/services-subsection.styles';
import { Container } from './parcel-details-dimensions.styles';
import ShipmentTypeSelector from './shipment-type-selector.component';
import ParcelDimensionsForm from './dimensions-form.component';
import NonStandardPackaging from './non-standard-packaging.component';

export interface DimensionsFormValues {
  weight: number | undefined;
  size_x: number | undefined;
  size_y: number | undefined;
  size_z: number | undefined;
}

const ParcelDetailsDimensions = () => {
  const {
    parcelCreationStore: { shipmentType },
  } = useStore();

  const { t } = useTranslation();

  const showDimensionsForm = shipmentType !== 'document';

  return (
    <Container>
      <ServicesSubSectionHeader id='parcel-dimensions-heading'>
        {t('package_info')}
      </ServicesSubSectionHeader>
      <ShipmentTypeSelector />
      <ParcelDimensionsForm isHidden={!showDimensionsForm} />
      <NonStandardPackaging />
    </Container>
  );
};

export default observer(ParcelDetailsDimensions);
